import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchRecommendedAiSkuMappings } from "../../../actions/aiSkuMappingActions";

const DEFAULT_PAGE_NUMBER = 1;
const DEFAULT_PAGE_SIZE = 10;

const useFetchRecommendedAiSkuMappings = () => {
  const [pageNumber, setPageNumber] = useState(DEFAULT_PAGE_NUMBER);
  const [pageSize, setPageSize] = useState(DEFAULT_PAGE_SIZE);
  const [totalResults, setTotalResults] = useState(0);
  const dispatch = useDispatch();

  const { response: aiSkuMappings, total } = useSelector(
    (state) => state.aiSkuMappings?.data || {},
  );
  useEffect(() => {
    if (total !== undefined && total !== null) {
      setTotalResults(total);
    }
  }, [total]);

  useEffect(() => {
    dispatch(fetchRecommendedAiSkuMappings(pageNumber, pageSize));
  }, [dispatch, pageNumber, pageSize]);

  return {
    aiSkuMappings,
    totalResults,
    pageNumber,
    pageSize,
    setPageNumber,
    setPageSize,
  };
};

export default useFetchRecommendedAiSkuMappings;
